export default __webpack_public_path__ + "static/media/WISE-IoTSuite.112a94f7.svg";